import React from 'react';
import { usePrefs } from 'wsm-common-data';

const InventoryIcon = () => {
	const { linkIconPlacement, linkIcon } = usePrefs();
	const showInventoryIcon = linkIcon.length > 0;
	const showInventoryIconBefore =
		showInventoryIcon && linkIconPlacement === 'before';

	return (
		showInventoryIcon && (
			<i
				className={`ddc-icon ddc-icon-${linkIcon} m${
					showInventoryIconBefore ? 'r' : 'l'
				}-3 line-height-reset`}
				data-testid="inventory-icon"
				aria-hidden="true"
			/>
		)
	);
};

export default InventoryIcon;
